/**
 * Color Swatches
 * This component is used in the product cards to switch between color variants
 * @extends HTMLElement
 */

 if(!customElements.get('color-swatches')) {
  class ColorSwatches extends HTMLElement {
    /** Instantiate a Color Swatches Element */
    constructor() {

      /**
       * Inherit HTMLElement methods
       * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/super
       */
      super();

      // Properties
      this.productImage = this.parentNode.querySelector('.product-image') || this.parentNode.parentNode.querySelector('.product-image');
      this.swatches = this.querySelectorAll('.variant-swatch-toggle');
      this.productLink = this.parentNode.querySelector('.product-card-link');
      this.switchImage = (this.getAttribute('data-switch-image') === 'true');

      // Set-up event listeners
      if (this.productImage !== null && this.swatches.length && this.switchImage) {
        for (let swatch = 0; swatch < this.swatches.length; swatch++) {
          this.swatches[swatch].addEventListener('click', this.swatchChange.bind(this, this.swatches[swatch]));
          this.swatches[swatch].addEventListener('focus', this.swatchChange.bind(this, this.swatches[swatch]));
        }
        // Set the first swatch as the active swatch on initial load
        this.swatchChange(this.swatches[0]);
      }
    }

    /**
     * Handler to update a product images src
     * @param {String} src The URL of the image that should be set as the src attribute on the target image.
     * @param {String} srcset The srcset string of the image variant that should be set as the srcset attribute on the target image.
     */
    changeProductImage(src, srcset) {
      if(typeof src === 'string' && typeof srcset === 'string' && src.length && srcset.length && this.productImage.src !== src && this.productImage.srcset !== srcset) {
        this.productImage.srcset = srcset;
        this.productImage.src = src;
      }
    }

    /**
     * Handler to update the product link to the color variant that is currently selected
     * @param {String} link The URL of the product with the variant id appended to the end of it (?variant=xxx)
     */
    changeProductLink(link) {
      if(typeof link === 'string' && link.length && this.productLink !== null) {
        this.productLink.href = link;
      }
    }

    /**
     * Swatch change event handler
     * @param {Object} swatch The swatch that triggered the product imahe change
     */
    swatchChange(swatch) {
      const variantImageUrl = swatch.getAttribute('data-variant-image');
      const variantImageSrcSet = swatch.getAttribute('data-variant-srcset');
      const variantLink = swatch.getAttribute('data-variant-link');
      // Check if the swatch has a valid image of the variant to switch to
      if(typeof variantImageUrl === 'string' && typeof variantImageSrcSet === 'string' && variantImageUrl.length && variantImageSrcSet.length) {
        this.changeProductImage(variantImageUrl, variantImageSrcSet);
        this.setActiveSwatch(swatch);
      }
      // Check if the swatch has a valid link to the variant's product page
      if(typeof variantLink === 'string' && variantLink.length) {
        this.changeProductLink(variantLink);
      }
    }

    /**
     * Sets the active class on a swatch
     * @param {Object} activeSwatch The swatch that should have the active class set.
     */
    setActiveSwatch(activeSwatch) {
      if(typeof activeSwatch === 'object') {
        for (var swatch = 0; swatch < this.swatches.length; swatch++) {
          this.swatches[swatch].classList.remove('active');
        }
        activeSwatch.classList.add('active');
      }
    }
  }

  /**
   * Define Web Component
   * @see https://developer.mozilla.org/en-US/docs/Web/API/CustomElementRegistry/define
   */
  customElements.define('color-swatches', ColorSwatches);
}
